// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/stylus/app.styl
// module id = 189
// module chunks = 1